document.addEventListener("DOMContentLoaded", function(event) {
    if (location.hash === '#checkout'
        && document.querySelector('.template-cart')
        && document.querySelector('.Cart__Checkout')) {
        document.querySelector('.Cart__Checkout').click();
    } else if (document.querySelector('.template-cart')) {
        document.querySelector('.template-cart').classList.add('is-active');
    }
});
// open select dropdown
document.addEventListener('focus',  (e) => {
    if (!e.target || !e.target.classList)  return;
    if (e.target.classList.contains('custom-select__input')) {
        const select = e.target.closest('.custom-select');
        const dropdown = select.querySelector('.custom-select__list');
        if (dropdown.style.display === 'none') {
            dropdown.closest('.custom-select').classList.add('is-open');
            slideDown(dropdown)
        }
    }

    if (e.target.classList.contains('input--error')) {
        e.target.classList.remove('input--error')
        if (document.querySelector('.email-box__error')) {
            document.querySelector('.email-box__error').remove();
        }
    } else  if (e.target.classList.contains('custom-select__input--address') && e.target.value == 'New Address') {
        e.target.value = '';
        e.target.closest('.form').querySelector('.CartItem__AddressForm').classList.add('is-hidden')
    }
}, true);
document.addEventListener('blur', (e) => {
    setTimeout(() => {
        const newFocusedElement = document.activeElement;
        if (!newFocusedElement.closest('.custom-select')) {
            closeDropdown(document.querySelectorAll('.custom-select__list'));
        }
    }, 0);
}, true);

document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
        const focusedElement = document.activeElement;
        if (focusedElement.closest('.custom-select')) {
            setTimeout(() => {
                const newFocusedElement = document.activeElement;
                if (!newFocusedElement.closest('.custom-select')) {
                    closeDropdown(document.querySelectorAll('.custom-select__list'));
                }
            }, 0);
        }
    }
}, true);

document.addEventListener('click', (e) => {
    if (e.target.closest('.custom-select__itm')) {
        closeDropdown(document.querySelectorAll('.custom-select__list'));
    }
}, true);

function closeDropdown(dropdowns) {
    dropdowns.forEach(dropdown => {
        if (dropdown.style.display === 'block' || dropdown.style.display === '') {
            dropdown.closest('.custom-select').classList.remove('is-open');
            dropdown.style.display = 'none'; // или ваша функция slideUp(dropdown)
        }
    });
}

document.addEventListener('keyup', function(e) {
    if (!e.target)  return;
    if (e.target.classList.contains('discount-box__input')) {
        let button = e.target.closest('.discount-box').querySelector('button')
        if (e.target.value.length> 3) {
            button.disabled = false
        } else {
            button.disabled = true
        }
    } else if (e.target.classList.contains('custom-select__input')) {
        let value = e.target.value;
        let searchList = [...e.target.closest('.custom-select').querySelectorAll('.custom-select__itm')]
        if (value) {
            searchList.map(item =>  {
                item.style.display = "block";
                if (!item.textContent.toLowerCase().includes(value.toLowerCase()) && item.textContent.toLowerCase() !== 'new address') {
                    item.style.display = "none";
                }
            })
        } else {
            searchList.map(e => e.style.display = "block" )
        }
    }
});

document.addEventListener('click', function(e) {
    if (!e.target)  return;
    if (e.target.dataset.type === 'delete-address') return;

    if (e.target.classList.contains('checkout-total__head') || e.target.closest('.checkout-total__head')) {
        let checkoutTotal = e.target.closest('.checkout-total');
        let checkoutTotalBody = checkoutTotal.querySelector('.checkout-total__body');
        let checkoutTotalTtl= checkoutTotal.querySelector('.checkout-total__ttl');
        let checkoutTotalHead= checkoutTotal.querySelector('.checkout-total__head');
        if (checkoutTotalHead.classList.contains('is-active')) {
            checkoutTotalHead.classList.remove('is-active');
            checkoutTotalTtl.textContent = 'Show order summary';
            slideUp(checkoutTotalBody)
        } else {
            checkoutTotalHead.classList.add('is-active');
            checkoutTotalTtl.textContent = 'Hide order summary';
            slideDown(checkoutTotalBody)
        }
    } else if (e.target.classList.contains('btn-edit') && e.target.classList.contains('contactsbox__btn-edit')) {
        if (window._cke_customer && window._cke_customer.id) {
            return;
        }
        const contactbox = e.target.closest('.contactsbox');
        contactbox.classList.remove('completed');
        contactbox.classList.add('edited');
        contactbox.querySelector('.contactsbox__input').removeAttribute('readonly');
    } else if (e.target.classList.contains('contactsbox__Button')) {
        const contactbox = e.target.closest('.contactsbox');
        const emailInp = e.target.closest('.contactsbox').querySelector('input');
        if (emailInp.value.match(/.+@.+\..+/i) ) {
            contactbox.classList.remove('edited');
            contactbox.classList.add('completed');
            document.querySelector('.checkout-total__buttons .form__label-error').classList.remove('is-error');
            contactbox.classList.contains('completed') ?
                emailInp.setAttribute('readonly', 'readonly') :
                emailInp.removeAttribute('readonly');
        }
    } else if (e.target.classList.contains('custom-select__itm--state')) {
        const input = e.target.closest('.custom-select').querySelector('[data-type="state-custom-input"]'),
              inputText = e.target.closest('.custom-select').querySelector('[data-type="state-text"]');
        input.value = e.target.dataset.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        inputText.value = e.target.textContent;
    } else if (e.target.classList.contains('custom-select__itm--country')) {
        const input = e.target.closest('.custom-select').querySelector('[data-type="country-custom-input"]'),
            inputText = e.target.closest('.custom-select').querySelector('[data-type="country-text"]');
        input.dispatchEvent(new Event('change', { bubbles: true }));
        inputText.value = e.target.textContent;
    } else if (e.target.classList.contains('custom-select__itm')) {
        const input = e.target.closest('.custom-select').querySelector('[data-type="address"]');
        const opitons = [...e.target.closest('.custom-select').querySelectorAll('.custom-select__itm')];
        input.value = e.target.dataset.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        opitons.map(option =>  {
            option.style.display = 'block';
        })

    } else if ( e.target.classList.contains('custom-select__icon'))  {
        const select = e.target.closest('.custom-select');
        const dropdown = select.querySelector('.custom-select__list');
        if (dropdown.style.display === 'none') {
            select.querySelector('.custom-select__input').focus();
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.code === "Enter" || e.keyCode === 13 || e.key === " " || e.code === "Space" || e.keyCode === 32 ) {
        if (e.target.classList.contains('custom-select__itm--state')) {
            const input = e.target.closest('.custom-select').querySelector('[data-type="state-custom-input"]'),
              inputText = e.target.closest('.custom-select').querySelector('[data-type="state-text"]');
            input.value = e.target.dataset.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            inputText.value = e.target.textContent;
            closeDropdown(document.querySelectorAll('.custom-select__list'));
        } else if (e.target.classList.contains('custom-select__itm--country')) {
            const input = e.target.closest('.custom-select').querySelector('[data-type="country-custom-input"]'),
              inputText = e.target.closest('.custom-select').querySelector('[data-type="country-text"]');
            input.dispatchEvent(new Event('change', { bubbles: true }));
            inputText.value = e.target.textContent;
            closeDropdown(document.querySelectorAll('.custom-select__list'));
        } else if (e.target.classList.contains('custom-select__itm')) {
            const input = e.target.closest('.custom-select').querySelector('[data-type="address"]');
            const opitons = [...e.target.closest('.custom-select').querySelectorAll('.custom-select__itm')];
            input.value = e.target.dataset.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            opitons.map(option =>  {
                option.style.display = 'block';
            })
            closeDropdown(document.querySelectorAll('.custom-select__list'));
        }
    }
});

document.addEventListener('change',  updateCartGiftName);

function updateCartGiftName(e) {
    if (!e.target) return;

    if (
      e.target.getAttribute('name') == 'properties[_gift_first_name]' ||
      e.target.getAttribute('name') == 'properties[_gift_last_name]'
    ) {
        let productBoxTitle = e.target.closest('.cart-product-box').querySelector('.top-line .gift-to'),
          giftName = e.target.closest('.product-gift').querySelector('[name="properties[_gift_first_name]"]'),
          giftLastName = e.target.closest('.product-gift').querySelector('[name="properties[_gift_last_name]"]');

        if ( giftName.value ) {
            productBoxTitle.innerHTML = 'Gift for ' + giftName.value + ' ' + giftLastName.value + ' - ';
        } else {
            productBoxTitle.innerHTML = "";
        }
    }
}
